import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ApiError } from '../../models/api-error.enum';
import { parseApiError } from '../../models/api-error.enum';
import type { FeatureFlagsMap } from '../models/feature-flags.model';
import { featureFlagService } from '../services/feature-flags.service';

export const loadFeatureFlags = createAsyncThunk<FeatureFlagsMap, void, { rejectValue: ApiError }>(
  'featureFlags/load',
  async (_, { rejectWithValue }) => {
    try {
      return await featureFlagService.getFeatureFlags();
    } catch (error) {
      return rejectWithValue(parseApiError(error));
    }
  }
);
